import { useEffect } from 'react';
import { useUserProjectsContext } from '../contexts/UserProjectsContext';
const SETTLING_RETRY_INTERVAL_MS = 3000;
// The owner of a just-created project can be denied its project-scoped calls
// for a few seconds: the server adds the project to its authorization policy on
// an asynchronous rebuild that the create call does not wait for. Each new
// request is checked against the latest policy, so re-issuing a denied fetch is
// all it takes. Retries run only where access is expected to change — the
// caller owns the project (an owner is never legitimately denied) and it is
// still processing (every new project starts there) — and stop at the first
// success, so a settled project is never polled.
//
// Returns true while a retry is pending, so a caller can show loading rather
// than the transient denial.
export const useAccessSettlingRetry = (projectId, denied, retry) => {
    const { projects } = useUserProjectsContext();
    const project = projectId ? projects.find(p => p.id === projectId) : undefined;
    const settling = denied && (project === null || project === void 0 ? void 0 : project.isOwner) === true && project.processingStatus === 'processing';
    useEffect(() => {
        if (!settling)
            return;
        const interval = setInterval(() => {
            if (!document.hidden)
                retry();
        }, SETTLING_RETRY_INTERVAL_MS);
        return () => clearInterval(interval);
    }, [settling, retry]);
    return settling;
};
